import React from 'react';

export default function ReportBody({ accidentHistory }) {
  const description = ["", "NO ACCIDENT", "LOW SEVERITY", "MEDIUM SEVERITY", "HIGH SEVERITY"]
  const fontColor = ["white", "green", "#adff2f", "#d97706", "red"]
  return(
    <div className="report-section">
      <h2>Accident History Assessment</h2>
      <table>
        <tbody>
          <tr>
            <th>Section</th>
            <th>Condition</th>
          </tr>
          <tr>
            <td>Front</td>
            <td style={{fontWeight:"bold", color:fontColor[accidentHistory.front]}}>{description[accidentHistory.front]}</td>
          </tr>
          <tr>
            <td>Rear</td>
            <td style={{fontWeight:"bold", color:fontColor[accidentHistory.rear]}}>{description[accidentHistory.rear]}</td>
          </tr>
          <tr>
            <td>Left</td>
            <td style={{fontWeight:"bold", color:fontColor[accidentHistory.left]}}>{description[accidentHistory.left]}</td>
          </tr>
          <tr>
            <td>Right</td>
            <td style={{fontWeight:"bold", color:fontColor[accidentHistory.right]}}>{description[accidentHistory.right]}</td>
          </tr>
          <tr>
            <td>Bottom</td>
            <td style={{fontWeight:"bold", color:fontColor[accidentHistory.bottom]}}>{description[accidentHistory.bottom]}</td>
          </tr>
          <tr>
            <td>Top</td>
            <td style={{fontWeight:"bold", color:fontColor[accidentHistory.top]}}>{description[accidentHistory.top]}</td>
          </tr>
          <tr>
            <td>Insurance Claim History</td>
            <td style={{fontWeight:"bold", color:fontColor[accidentHistory.insurance]}}>{description[accidentHistory.insurance]}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

